import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const HeaderContainer = styled.div`
  align-items: start;
  display: flex;
  gap: 1rem;
`;

export const IconButton = styled(Button)`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  color: #3a84d8;
  padding: 0;
  margin: 0;

  &:hover {
    background-color: #eee;
  }

  svg {
    height: 20px;
    width: 20px;
  }
`;

export const IconLink = styled(Link)`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  color: #3a84d8;

  &:hover {
    background-color: #eee;
  }

  svg {
    height: 20px;
    width: 20px;
  }
`;
